import { combineReducers } from "redux";
import userReducer from "./userReducer";
import placeReducer from "./placeReducer";
import airlineReducer from "./airlineReducer";

const reducers = combineReducers({
  user: userReducer,
  places: placeReducer,
  airlines: airlineReducer,
});

export default reducers;

export type State = ReturnType<typeof reducers>;